import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

// Versões da página principal
const V1Index = lazy(() => import("@/v1_site/pages/Index"));
const V2Index = lazy(() => import("@/pages/v2/Index"));

// Demais páginas carregam sob demanda (lazy loading = chunks menores)
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const Success = lazy(() => import("./pages/Success"));
const ExtensionCallback = lazy(() => import("./pages/ExtensionCallback"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const ComoFazerCandidaturasSimplificadasLinkedin = lazy(
  () => import("./pages/ComoFazerCandidaturasSimplificadasLinkedin")
);
const ExtensaoChromeLinkedinVagas = lazy(
  () => import("./pages/ExtensaoChromeLinkedinVagas")
);
const IaParaBuscaDeEmprego = lazy(() => import("./pages/IaParaBuscaDeEmprego"));
const ComparativoFerramentasAutomacao = lazy(
  () => import("./pages/ComparativoFerramentasAutomacao")
);

// Rotas Administrativas
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));

import { LeadCaptureProvider } from "./contexts/LeadCaptureContext";
import LeadCaptureModal from "./components/v2/LeadCaptureModal";
import ProtectedRoute from "./components/ProtectedRoute";

const queryClient = new QueryClient();

// Fallback leve durante carregamento de páginas secundárias
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LeadCaptureProvider>
        <LeadCaptureModal />
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<V1Index />} />
              <Route path="/apply" element={<V2Index />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/success" element={<Success />} />
              <Route path="/auth/extension/callback" element={<ExtensionCallback />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route
                path="/como-fazer-candidaturas-simplificadas-linkedin"
                element={<ComoFazerCandidaturasSimplificadasLinkedin />}
              />
              <Route path="/extensao-chrome-linkedin-vagas" element={<ExtensaoChromeLinkedinVagas />} />
              <Route path="/ia-para-busca-de-emprego" element={<IaParaBuscaDeEmprego />} />
              <Route
                path="/comparativo-ferramentas-automacao"
                element={<ComparativoFerramentasAutomacao />}
              />
              
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                </Route>
              </Route>
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </LeadCaptureProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
